export default __webpack_public_path__ + "icon-chevron-right.31c8936b.png";